export * from './IconDocFilled';
